<script>
export default {
  props: {
    module: Object,
  },
  data: () => ({
    valid: true,
    rules: [v => !!v || 'Введите пароль'],
  }),
  methods: {
    handlerSubmit() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.module.submit()
        .catch((e) => {
          this.module.parent.notify.error(e);
        });
    },
    handlerClose() {
      this.module.redirect();
    },
  },
};
</script>
<template>
  <v-dialog
    :value="module.show"
    max-width="420px"
    persistent
  >
    <v-card v-if="module.show">
      <v-card-title>
        <span class="headline">Повторная авторизация</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-text-field
              v-model="module.agency"
              label="ID Агентства"
              disabled
            ></v-text-field>
            <v-text-field
              v-model="module.login"
              label="Логин"
              disabled
            ></v-text-field>
            <v-text-field
              v-model="module.password"
              label="Пароль"
              :rules="rules"
              required
            ></v-text-field>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="handlerClose"
        >
          Выйти
        </v-btn>
        <v-btn
          :disabled="!valid"
          color="primary"
          @click="handlerSubmit"
        >
          Подтвердить
        </v-btn>
      </v-card-actions>
      <v-overlay :value="module.loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>
<style lang="scss">
</style>
